import { useEffect, useRef, useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { useFormikContext } from "formik";
import AddButton from "../buttons/button";
import { MapPin } from "lucide-react";
import AddressSidebarSales from "../common-components/address-bar-sales";
import Funnel from "../../assets/icons/funnel";
import OutstandingBalanceInfo from "../helper-components/outstanding-bal-information";
import LoadingButtonSpinner from "../helper-components/loading-button-spinner";
import excelImg from "../../assets/icons/excel.png";
import { PastBillsIcon } from "../../assets/icons/invoice-header-icons";
import BillingPastBillPanel from "../invoice-section/billing-past-bills-top-products";
import SalesPurchaseSidePanel from "./sales-purchase-side-panel";
import SelectField from "../forms/select-field";
import { newWareHouseListAction } from "../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import PurchaseReturnSidePanel from "../purchase-section/purchase-return/purchase-return-side-panel";
import { downloadAllTemplates } from "../helper-components/helper-function";
import DownloadIcon from "../../assets/icons/download-icon";
const SalesPurchaseTopBar = ({
  pageType,
  page,
  isClone = false,
  autoDraft,
  clickedplus,
  name = "",
  disabled = false,
  tempalteArray = [],
  loading,
  csvTemLoading = false,
  fetchCreditNoteFn = () => {},
  handleFileUpload = () => {},
  csvButtonText = "Import CSV",
  importcsv = false,
}) => {
    const dispatch=useDispatch();
    const { errors, values, setFieldValue, setFieldError } = useFormikContext();
    const [addressPanel, setAddressPanel] = useState(false);
    const [customerId, setCustomerId] = useState(values.cmr_id);
    const [creditNotesOpen, setCreditNotesOpen] = useState(false);
    const [PastBillPanel, setPastBillPanel] = useState(false);
    const [open,setOpen]=useState(false);
    const addressRef = useRef(null);
    const filtersRef=useRef(null);
    const importRef=useRef(null);
    const pastOrders=useRef(null);
    const handleToggle = (e) => {
    e.preventDefault();
    if (page !== "view") {
      setFieldValue("is_local_purchase", !values.is_local_purchase);
        } else return;
    };
    const mapListToOptions = (data) => {
    return (
      data?.data?.map((item) => ({
        label: item?.warehouse_name,
        value: item?.warehouse_id, // e.g. 123
      })) || []
    );
  };
  const onListSuccess = (data) => {
    setWarehouseList(mapListToOptions(data));
    console.log("lll", data);
  };
    const onListError = (data) => {};
    useEffect(() => {
        dispatch(newWareHouseListAction(onListSuccess, onListError));
    }, []);
    const [warehouseList, setWarehouseList] = useState([]);
    useHotkeys("L", () => {
        if (addressRef.current && values?.cmr_name) {
          addressRef.current.click();
        }
    });
    useHotkeys("f", () => {
        if (filtersRef.current) {
          filtersRef.current.click();
        }
    });
    useHotkeys("I", () => {
        if (importRef.current) {
            importRef.current.click();
        }
    });
    useHotkeys("P", () => {
        if (pastOrders.current) {
            pastOrders.current.click();
        }
    });
    // function handleFileUpload(){
    //     alert("Clicked Import");
    // }
    return (
        <div className="mt-[1rem] flex justify-between w-full">
        <div>
            {pageType === "purchase invoice" && (
          <div className="flex flex-row gap-3 items-center">
            <label className="text-[length:var(--purchase-invoice-toggle-label-fs)] font-[var(--purchase-invoice-toggle-label-fw)]">
              Local Purchase
            </label>
            <button
              type="button"
              onClick={handleToggle}
              className={`
            relative inline-flex h-6 w-10 items-center rounded-full transition-colors duration-300 ease-in-out focus:outline-none
            ${
              values.is_local_purchase
                ? "bg-[var(--primary)]"
                : "bg-[var(--purchase-invoice-toggle-bg)]"
            }
          `}
              aria-pressed={values.is_local_purchase}
              aria-label="Toggle button"
            >
              <span
                className={`
              inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-300 ease-in-out
              ${values.is_local_purchase ? "translate-x-5" : "translate-x-1"}
            `}
              />
            </button>
          </div>
      )}
        </div>
        <div className="overflow-x-auto max-w-full">
            <div className="flex gap-[8px] w-max">
                {pageType ==="purchase return" && <AddButton
                ref={filtersRef}
                icon={<Funnel size={13} />}
                text={
                    <>
                    Load Items with Filters <span className="opacity-50">(F)</span>
                    </>
                }
                className={`flex shrink-0 items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px]
                            bg-[var(--general-button-bg)] cursor-pointer 
                            border border-[var(--general-button-border)] 
                            hover:bg-[var(--general-button-bg)]
                            `}
                onclkFn={() => {
                    setOpen(prev => !prev);
                }}
                />}
                {pageType === "purchase invoice" &&
                    <SelectField
                        containerClass="flex-1 min-full"
                        placeholder="Select Warehouse"
                        options={warehouseList}
                        label="On behalf of:"
                        id="on_behalf_of_name"
                        name="on_behalf_of_name"
                        isSearchable={true}
                        errMsgContainerClass="hidden"
                        // isRequired={true}
                        handleSelected={(selectedOption) => {
                            setFieldValue("on_behalf_of_name", selectedOption.label);
                            setFieldValue("on_behalf_of_id", selectedOption.value);
                        }}
                        labelWidth="6rem"
                        isDisabled={!values.is_local_purchase || disabled}
                    />
                }
                <AddButton
                ref={addressRef}
                icon={<MapPin size={13} />}
                text={
                    <>
                    Address Details <span className="opacity-50">(L)</span>
                    </>
                }
                className={`flex shrink-0 items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px]
                            bg-[var(--general-button-bg)] cursor-pointer 
                            border border-[var(--general-button-border)] 
                            hover:bg-[var(--general-button-bg)]
                            ${
                                values?.cmr_name
                                ? "text-[var(--general-button-fg)]"
                                : "text-[var(--general-button-disabled-fg)] opacity-60 pointer-events-none"
                            }`}
                onclkFn={() => {
                    setAddressPanel(!addressPanel);
                }}
                />

                <OutstandingBalanceInfo
                conClasss="conClasss flex shrink-0 items-center justify-between gap-7 bg-[var(--out-standing-bg)] px-3 rounded-lg border border-[var(--out-standing-border)] shadow-sm h-[45px] cursor-pointer"
                onClick={fetchCreditNoteFn}
                badgeText={<span className="flex items-center gap-2">CR/DB</span>}
                />

                {importcsv && !disabled && (
                    <>
                        {name === "pot" && (
                        <input
                            type="file"
                            accept=".csv"
                            onChange={(e) => {
                            // e.target.value = ""; // Reset input value
                            handleFileUpload(e, "vendor");
                            }}
                            className="hidden"
                            id="csv-upload"
                        />
                        )}
                        {name === "pot" ? (
                        <label htmlFor="csv-upload">
                            <div
                            className="flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] 
                    bg-[var(--import-button-bg)] cursor-pointer 
                    border border-[var(--import-button-border)] 
                    hover:bg-[var(--import-button-bg)] 
                    text-[var(--import-button-fg)]"
                            >
                            <img
                                width={20}
                                height={30}
                                src={excelImg}
                                alt="excel-icon"
                            />
                            {loading || csvTemLoading ? (
                                <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                            ) : (
                                <span>{csvButtonText}</span>
                            )}
                            </div>
                        </label>
                        ) : (
                        <AddButton
                            onclkFn={handleFileUpload}
                            icon={
                            <img
                                width={20}
                                height={30}
                                src={excelImg}
                                alt="excel-icon"
                            />
                            }
                            text={
                            <>
                                {loading || csvTemLoading ? (
                                <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                                ) : (
                                <span>
                                    {" "}
                                    {csvButtonText}
                                    <span className="opacity-50">(I)</span>
                                </span>
                                )}
                            </>
                            }
                            className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] 
                    bg-[var(--import-button-bg)] cursor-pointer 
                    border border-[var(--import-button-border)] 
                    hover:bg-[var(--import-button-bg)] 
                    text-[var(--import-button-fg)]`}
                        />
                        )}

                        {name === "pot" && (
                        <button
                            type="button"
                            onClick={() => {
                            downloadAllTemplates(tempalteArray);
                            }}
                            className="border border-[var(--import-button-border)] rounded-[8px] px-[12px] h-[44px]"
                        >
                            <DownloadIcon fill="var(--success-color)" />
                        </button>
                        )}
                    </>
                    )}

                <AddButton
                ref={pastOrders}
                icon={<PastBillsIcon />}
                text={
                    <>
                    Past Bills <span className="opacity-50">(P)</span>
                    </>
                }
                className={`flex shrink-0 items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] 
                            gap-[8px] bg-[var(--general-button-bg)] cursor-pointer 
                            border border-[var(--general-button-border)] 
                            hover:bg-[var(--general-button-bg)]
                            ${
                                !disabled && values?.cmr_id
                                ? "text-[var(--general-button-fg)]"
                                : "text-[var(--general-button-disabled-fg)] opacity-60 pointer-events-none"
                            }`}
                onclkFn={() => {
                    setPastBillPanel(!PastBillPanel);
                }}
                />
            </div>

            {/* Side panels / drawers (not part of the scroll row visually) */}
            <AddressSidebarSales
                isClone={isClone}
                autoDraft={autoDraft}
                clickedplus={clickedplus}
                pageType={pageType}
                open={addressPanel}
                setOpen={setAddressPanel}
                id={
                !isClone && pageType === "sales"
                    ? page === "add"
                    ? customerId
                    : values.cmr_id
                    : values.cmr_id
                }
                name={name}
                page={page}
                disabled={disabled}
            />

            <BillingPastBillPanel
                open={PastBillPanel}
                setOpen={setPastBillPanel}
            />

            <PurchaseReturnSidePanel //SalesPurchaseSidePanel
                open={open}
                setOpen={setOpen}
            />
        </div>
        </div>

    );
}

export default SalesPurchaseTopBar;